/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiUrl: 'https://api.delivereasy.com',
  mapApiKey: 'AIzaSyChO53aVJ2yS14KQRkKpEay6eXmSifzPEU', // Tom Api Key
};
